/** Форматирование чисел и дат. Разряды — неразрывным пробелом, как принято. */

const INTEGER = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });
const DECIMAL = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatNumber(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "да" : "нет";
  if (typeof value === "number") {
    return Number.isInteger(value) ? INTEGER.format(value) : DECIMAL.format(value);
  }
  return String(value);
}

const MONTHS_SHORT = [
  "янв",
  "фев",
  "мар",
  "апр",
  "мая",
  "июн",
  "июл",
  "авг",
  "сен",
  "окт",
  "ноя",
  "дек",
];

export function formatDate(iso: string): string {
  const [year, month, day] = iso.split("-");
  if (!year || !month || !day) return iso;
  return `${Number(day)} ${MONTHS_SHORT[Number(month) - 1] ?? month} ${year}`;
}

/** Подпись точки ряда по шагу: у месяца день не нужен, у дня — нужен. */
export function formatBucket(iso: string, granularity: string | null): string {
  const [year, month, day] = iso.split("-");
  if (!year || !month || !day) return iso;
  if (granularity === "month") return `${MONTHS_SHORT[Number(month) - 1] ?? month} ${year}`;
  return `${Number(day)} ${MONTHS_SHORT[Number(month) - 1] ?? month}`;
}
